module.exports = __webpack_public_path__ + "static/media/UnknownError.d17e411d.svg";